
<template>
  <div class="d-flex">
    <div class="content-fixed">
      <p class="content-title">{{data.detailsText.title}}</p>
      <p class="content-line" />
      <div>
        <p class="content-warn">{{data.detailsText.warn}}</p>
        <p class="content-content">{{data.detailsText.content}}</p>
        <!-- <div class="content-icon" alt="下划线" /> -->
      </div>
    </div>

    <div class="content-scroll">
      <div class="content-scroll-wrapper" v-for="item in data.detailsText.illustrate" :key="item.id">
        <p class="content-scroll-rank">{{item.rank}}</p>
        <p class="content-scroll-illustrate">{{item.illustrateContent}}</p>
      </div>
      <p class="content-scroll-warn">{{data.detailsText.illustrateWarn}}</p>
    </div>

    <div class="content-btn">
      <a class="btn-download-link" :href="data.detailsText.downloadLink" target="_blank">
        <div class="btn-download">
          {{data.detailsText.download}}
        </div>
      </a>
      <a class="btn-study-link" :href="data.detailsText.studyLink" target="_blank">
        <div class="btn-study">
          {{data.detailsText.study}}
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: ['data']
}
</script>

<style lang="scss" scoped>
.content-fixed {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;
}

.content-title {
  position: relative;
  margin: 0 auto 3px;
  color: #2F2F30;
  line-height: 22px;
  font-size: 16px; font-weight: 500;

  // &::after {
  //   content: " ";
  //   position: absolute; top: 34px; left: 50%;
  //   transform: translateX(-50%);
  //   width: 28px; height: 4px;
  //   background: #DE3640;
  // }
}

.content-line {
  width: 28px; height: 4px;
  background: #DE3640;
}

.content-warn {
  margin-bottom: 20px;
  color: #828A92;
  line-height: 20px;
  font-size: 14px; font-weight: 400;
}

.content-content {
  margin-bottom: 20px;
  color: #2F3030;
  line-height: 28px;
  font-size: 14px; font-weight: 400;
}

// .content-icon {
//   width: 302px; height: 2px;
//   margin: 0 auto 20px;
//   background: url('~@/assets/transSave/resource/image/52/04/52a96eb9d55cd087d0204dfc414af104.png') center / cover no-repeat;
// }

// .content-scroll {
//   overflow-y: scroll;
// }

.content-scroll-wrapper {
  margin-bottom: 20px;
}

.content-scroll-rank {
  margin-bottom: 20px;
  color: #2F2F30;
  line-height: 22px;
  font-size: 16px; font-weight: 500;
}

.content-scroll-illustrate {
  color: #2F3030;
  line-height: 24px;
  font-size: 14px; font-weight: 400;

  @include mobile {
    max-height: 300px;
    overflow-y: auto;
    text-align: left;
  }
}

.content-btn {
  display: flex;
  justify-content: center;
}

.btn-download-link {
  display: inline-block;
  width: 110px; height: 36px;
  margin-right: 66px;
  color: #353535;

  &:hover {
    // color: #3976FF;
    font-weight: 500;
  }
}

.btn-download {
  // border-radius: 18px;
  border: 1px solid #000000;
  line-height: 36px;
}

.btn-study-link {
  display: inline-block;
  width: 110px; height: 36px;
  color: #353535;

  &:hover {
    font-weight: 500;
  }
}

.btn-study {
  // border-radius: 18px;
  border: 1px solid #000000;
  line-height: 36px;
}

.content-scroll-warn {
  color: #828A92;
  line-height: 28px;
  font-size: 14px; font-weight: 400;
}

// 默认出现滚动条
.content-scroll::-webkit-scrollbar {
 -webkit-appearance: none;
 }

 .content-scroll::-webkit-scrollbar:vertical {
   width: 7px;
 }

 .content-scroll::-webkit-scrollbar:horizontal {
   height: 0.06rem;
 }

.content-scroll::-webkit-scrollbar-thumb {
  // border: 2px solid white; /* should match background, can't be transparent */
  background-color: #d8d8d8;
  border-radius: 5px;
}

</style>
